import { connect } from "react-redux"

import {
    notificationListInvalidationRequest,
    notificationSetFilter,
    notificationAddNew,
} from "../../../actions/notification-actions"

import NotificationsListWidget from "./NotificationsListWidget"

const mapStateToProps = ({
    presentation: { notifications },
    paging,
    authentication,
}) => ({
    isFetching:
        notifications.isFetchingList ||
        notifications.isFetchingItem ||
        notifications.isDeletingItem,
    pagingRequest: paging.notifications[notifications.searchCriteria],
    isAddingEnabled: authentication.permissions.indexOf("w_user") !== -1,
})

const mapDispatchToProps = (dispatch) => ({
    invalidate: (pagingRequest) => () =>
        dispatch(notificationListInvalidationRequest(pagingRequest)),
    onFilterSelect: (pagingRequest) => () =>
        dispatch(notificationSetFilter(true, pagingRequest.searchCriteria)),
    onAdd: () => dispatch(notificationAddNew()),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NotificationsListWidget)
